import { connect } from 'react-redux';
import Production from './Production';
import { getSemiProducts } from '../../store/actions/semiProducts';
import {
  getOperation,
  saveOperation
} from '../../store/actions/inputOperation';
import { getAvailableOperations } from '../../store/actions/configurator';
import { getReadyProducts } from '../../store/actions/correctionReadyProducts';

const mapStateToProps = ({
  userReducer,
  semiProductsReducer,
  tabsReducer,
  savedProductsReducer,
  settingsReducer,
  inputOperationReducer,
  configuratorReducer,
  correctionSemiProductsReducer
}) => ({
  userReducer,
  semiProductsReducer,
  tabsReducer,
  savedProductsReducer,
  settingsReducer,
  inputOperationReducer,
  configuratorReducer,
  correctionSemiProductsReducer
});
const mapDispatchToProps = {
  getSemiProducts,
  getOperation,
  saveOperation,
  getAvailableOperations,
  getReadyProducts
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Production);
